import React from 'react'
import { IconButton } from '../CustomButton'
import { capitalizeFirstLetter, capitalizeAndRemoveUnderscore } from '../../helpers/stringHelper'

const Chip = ({ label, onClick, children }) => {
  return (
    <div className="flex items-center p-1 pl-3 mb-1 mr-1 text-sm text-white rounded-full bg-rand-100">
      {children !== undefined? (
         children
      ) : (
        <div className="mr-1.5">{capitalizeAndRemoveUnderscore(label)}</div>
      )}
      <IconButton onClick={onClick} className="bg-slate-600" />
    </div>
  )
}

export default Chip
